<ng-container *ngIf="data.type === 'modality-change'; else legacyDialog">
  <h2 mat-dialog-title>
    <mat-icon color="warn">warning</mat-icon>
    {{ 'FirmwareUpdate.ModalityChangeTitle' | translate }}
  </h2>
  <mat-dialog-content>
    <p>
      {{ uniqueTargetLabels.length === 1
        ? (('FirmwareUpdate.ModalityChangeMessage' | translate: { modality: uniqueTargetLabels[0] }))
        : ('FirmwareUpdate.ModalityChangeMessageGeneric' | translate) }}
    </p>
    <div class="device-list">
      <div *ngFor="let d of modalityDevices" class="device-item">
        <span class="device-mac">{{ d.mac }}</span>
        <span class="device-version">v{{ d.currentVersion }} [{{ d.currentLabel }}] → v{{ d.targetVersion }} [{{ d.targetLabel }}]</span>
        <span *ngIf="d.warning" class="device-warning">
          <mat-icon color="warn">warning</mat-icon>
          {{ 'FirmwareUpdate.ZigbeeModuleWarning' | translate }}
        </span>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{ 'Shared.Cancel' | translate }}</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      {{ 'FirmwareUpdate.ConfirmModalityChange' | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #legacyDialog>
  <h2 mat-dialog-title>
    <mat-icon [color]="data.type === 'downgrade' ? 'warn' : 'accent'">{{ data.type === 'downgrade' ? 'warning' : 'info' }}</mat-icon>
    {{ data.type === 'downgrade' ? ('FirmwareUpdate.DowngradeTitle' | translate) : ('FirmwareUpdate.ReinstallTitle' | translate) }}
  </h2>
  <mat-dialog-content>
    <p>{{ data.type === 'downgrade' ? ('FirmwareUpdate.DowngradeMessage' | translate) : ('FirmwareUpdate.ReinstallMessage' | translate) }}</p>
    <div class="device-list">
      <div *ngFor="let d of data.devices" class="device-item">
        <span class="device-mac">{{ d.mac }}</span>
        <span class="device-version">v{{ d.currentVersion }} → v{{ d.targetVersion }}</span>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{ 'Shared.Cancel' | translate }}</button>
    <button mat-raised-button [color]="data.type === 'downgrade' ? 'warn' : 'primary'" [mat-dialog-close]="true">
      {{ data.type === 'downgrade' ? ('FirmwareUpdate.ConfirmDowngrade' | translate) : ('FirmwareUpdate.ConfirmReinstall' | translate) }}
    </button>
  </mat-dialog-actions>
</ng-template>
